export default {
  Validate: {
    ErrorDisposalDateBeforePurchaseDate: "Ngày mất phải lớn hơn hoặc bằng ngày mua",
    ErrorOccurenceDateLiquidation: "Ngày thanh lý phải lớn hơn hoặc bằng ngày ##0##.",
    ErrorDisposalDateBeforeAllocateDate: "Ngày mất phải lớn hơn hoặc bằng ngày đưa vào sử dụng",
    QuantityError: "Số lượng mất phải nằm trong khoảng từ 1 đến ##0##",
    ErrorDateBefor: "Ngày mất phải lớn hoặc bằng ##0##",
  },
};
